var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.19048 2.25L5.85714 5.75L2.52381 2.25","stroke":_vm.$attrs.color,"stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }